import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.163 8.409c2.696.423 5.324-1.262 6.043-3.966l-1.45-.386c-.559 2.103-2.7 3.342-4.776 2.781l-.559-.15-4.38 7.644c-.287.5-.69.921-1.173 1.228m6.295-7.151l-3.821 6.67a5.03 5.03 0 01-1.671 1.748c-.315.2-.16.673.188.673h1.518c.784 0 1.557-.208 2.237-.604l7.865-4.574a2.069 2.069 0 00.746-2.813l-1.51-2.637 1.301-.746 1.51 2.636a3.57 3.57 0 01-1.293 4.857l-7.865 4.574A5.954 5.954 0 017.377 19H5.859c-1.874 0-2.555-2.45-.991-3.44",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.259 12.835c-.57-.063-.604-.828-.597-1.065-.071.328-.142.655-.159.978-.026.504.104.966.414 1.131.56.298 1.132-.32 1.467-.762L15.5 9l-3.45 3.425c-.29.286-.57.432-.791.41z",
    clipRule: "evenodd"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.43 14.366c-.464.614-1.256 1.469-2.03 1.056-.431-.228-.611-.868-.573-1.567.022-.447.12-.901.219-1.355-.01.33.037 1.389.827 1.476.305.03.695-.172 1.096-.568l4.777-4.743-4.315 5.7zM21.905 7.7l-3.25-5.63c.034-.11.074-.214.103-.325l-1.45-.39a5.514 5.514 0 01-6.744 3.896l-.557-.15L4.213 15.14a4.999 4.999 0 01-1.663 1.727 2.222 2.222 0 00-.96 2.514A2.221 2.221 0 003.743 21h2.042a7.8 7.8 0 003.892-1.043l10.58-6.11a4.473 4.473 0 002.098-2.731 4.476 4.476 0 00-.45-3.415z",
    clipRule: "evenodd"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M22.861 28.731c-.93 1.228-2.514 2.938-4.062 2.112-.862-.456-1.222-1.736-1.146-3.134.044-.894.242-1.802.438-2.71-.02.66.074 2.778 1.654 2.952.61.062 1.39-.344 2.192-1.136l9.554-9.486-8.63 11.402zm20.946-13.33l-6.5-11.26c.068-.218.148-.428.206-.65l-2.898-.778c-1.57 5.868-7.626 9.36-13.49 7.79l-1.114-.298L8.423 30.281a9.998 9.998 0 01-3.326 3.454 4.443 4.443 0 00-1.918 5.028A4.442 4.442 0 007.483 42h4.084c2.728 0 5.42-.722 7.784-2.086l21.162-12.218a8.947 8.947 0 004.194-5.464 8.953 8.953 0 00-.9-6.83z",
    clipRule: "evenodd"
  }))
};
export var ShoeFilled = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});